export function isWholesalePath(pathname: string): boolean {
  return pathname === "/opt" || pathname.startsWith("/opt/");
}
